module.exports = __webpack_public_path__ + "img/002.9b2ca5aa.jpg";